export enum FormEvent {
  SUBMIT,
  RESET,
  SAVE
}
